const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the check image attr directive
 */
app.directive('checkImage',[function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      element.on('error',(function(){
            element.attr('src', '//cdn-latest.continu.co/img/avatar-default.png');
      }));
    }
  };
}] );